/** @jsx jsx */
import { ClassNames, jsx } from '@emotion/react';
import React from 'react';

const DownloadIcon: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <ClassNames>
      {({ cx, css }) => (
        <svg xmlns='http://www.w3.org/2000/svg' width='35' height='35' viewBox='0 0 35 35' css={cx(css(), className)}>
          <defs>
            <path id='path-4' fillRule='evenodd' d='M12 25.5h11' />
          </defs>
          <g>
            <ellipse cx='17.5' cy='17.5' fill='rgb(157,193,65)' rx='17.5' ry='17.5' />
            <path
              fill='none'
              stroke='rgb(255,255,255)'
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth='2'
              d='M23 16l-5.5 5-5.5-5'
            />
            <path
              fill='none'
              stroke='rgb(255,255,255)'
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth='2'
              d='M17.5 8v13'
            />
            <g>
              <use fill='rgb(200,200,200)' />
              <use
                fillOpacity='0'
                stroke='rgb(255,255,255)'
                strokeLinecap='round'
                strokeLinejoin='miter'
                strokeWidth='2'
              />
            </g>
          </g>
        </svg>
      )}
    </ClassNames>
  );
};

export default DownloadIcon;
